{
  "version": 1,
  "asset_id": "fbbac75b-9b3e-4883-b897-56bc17d3c4bb",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/fbbac75b-9b3e-4883-b897-56bc17d3c4bb/metal-roof-installation-citrus-county-fl-1024.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/fbbac75b-9b3e-4883-b897-56bc17d3c4bb/metal-roof-installation-citrus-county-fl-1024.webp",
  "original_filename": "metal-roof-installation-citrus-county-fl-1024.webp",
  "size": 101658,
  "content_type": "image/webp",
  "created_at": "2026-07-16T15:36:28Z"
}
